import { CircularProgress, Typography } from "@mui/material";
import { Formik } from "formik";
import { useSelector } from "react-redux";
import * as yup from "yup";
import LoginLayoutWrapper from "../commons/layout/LogginLayoutWrapper";
import { StyledLogin } from "../styled/Login";

const validationSchema = yup.object({
  usuario: yup.string().required("Campo obligatorio"),
  claveRecuperacion: yup
    .string()
    .required("Campo obligatorio"),
  claveNueva: yup
    .string()
    .min(6, "La contraseña debe tener un mínimo de 6 caracteres")
    .max(20, "La contraseña debe tener un máximo de 20 caracteres")
    .required("Campo obligatorio"),
  confirmarClaveNueva: yup
    .string()
    .max(20, "La contraseña debe tener un máximo de 20 caracteres")
    .oneOf([yup.ref('claveNueva'), null], 'Las contraseñas deben coincidir')
    .required("Campo obligatorio"),
});

const CambiarClaveRecuperacion = ({ handleSubmit, defaultUsuario }) => {
  const loading = useSelector((state) => state.auth.changeRecoveryPassword?.loading);

  const initialValues = {
    usuario: defaultUsuario || "",
    claveRecuperacion: "",
    claveNueva: "",
    confirmarClaveNueva: "",
  };

  return (
    <LoginLayoutWrapper>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        <StyledLogin.Form>
          <Typography variant="body1" align="center" style={{ marginTop: '10px', textWrap: 'wrap', maxWidth: 500 }}>
            Te hemos enviado una clave de recuperación a tu correo electrónico. Por favor, ingrésala a continuación.
          </Typography>
          {!defaultUsuario && (
            <div>
              <StyledLogin.TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Usuario"
                name="usuario"
                autoFocus
                type="text"
              />
            </div>
          )}
          <div>
            <StyledLogin.Password
              variant="outlined"
              margin="normal"
              fullWidth
              name="claveRecuperacion"
              label="Clave de recuperación"
              autoFocus={!!defaultUsuario}
            />
          </div>
          <div>
            <StyledLogin.Password
              variant="outlined"
              margin="normal"
              fullWidth
              name="claveNueva"
              label="Nueva contraseña"
              inputProps={{ maxLength: 20 }}
            />
          </div>
          <div>
            <StyledLogin.Password
              variant="outlined"
              margin="normal"
              fullWidth
              name="confirmarClaveNueva"
              label="Confirmar nueva contraseña"
              inputProps={{ maxLength: 20 }}
            />
          </div>
          <StyledLogin.Button
            color="primary"
            variant="contained"
            fullWidth
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} thickness={4} color="primary" />
            ) : (
              "Cambiar Contraseña"
            )}
          </StyledLogin.Button>
        </StyledLogin.Form>
      </Formik>
    </LoginLayoutWrapper>
  );
};

export default CambiarClaveRecuperacion;
